import { constants } from "@layout";
import styled from "styled-components";

export const Separator = styled.div`
  width: ${constants.divPadding}px;
`;
